import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../../../../utils/JumpTo.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  get_status1d77371nrw24k as get_status,
  ChangeStatus_Accepted_getInstance2k8febn59t1nq as ChangeStatus_Accepted_getInstance,
  ChangeStatus_Rejected_getInstance5u2zdbak9nj5 as ChangeStatus_Rejected_getInstance,
  status2ejx1l1gl01uw as status,
} from '../data.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MINUTES_getInstancejlptjvjgjkm8 as DurationUnit_MINUTES_getInstance } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../../../../sdk/errors.mjs';
import {
  LineItem2rt64afaiyloc as LineItem,
  PendingItemChange1hwhwykx2kyit as PendingItemChange,
  PendingLineItem7uj25viy3ie8 as PendingLineItem,
  ChangeRequesthd3ysa2j1i4f as ChangeRequest,
} from '../../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  LineItemInterface2ct3y0vtnbxod as LineItemInterface,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__unaryMinus_impl_x5smq036mvwk2sni6rt as MonetaryValue__unaryMinus_impl_x5smq0,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  get_pending3bzoyvzwzq8kn as get_pending,
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  ChangeRequestItem25pmay5za3qvv as ChangeRequestItem,
} from '../../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import {
  ApprovedSemantic_getInstance10vizqzbc90jx as ApprovedSemantic_getInstance,
  DeniedSemantic_getInstanceb7su0ait1it4 as DeniedSemantic_getInstance,
  ReviewSelectionSemantic_getInstance79bht8dtdj2a as ReviewSelectionSemantic_getInstance,
} from '../../../../../theming/approval.mjs';
import {
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  DarkSection_getInstance2gsqmxxo07g1v as DarkSection_getInstance,
  LightSection_getInstance1p9fz392synu9 as LightSection_getInstance,
  get_lightSection4cpu8okr0w14 as get_lightSection,
  SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance,
  get_darkSection25mxxvxk8ts3b as get_darkSection,
} from '../../../../../theming/sections.mjs';
import {
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_compact3lsezez8nz8b6 as get_compact,
  get_italic11nskfy97pz2f as get_italic,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { LineItemDetailsPage1m0bbf89e2gid as LineItemDetailsPage } from '../../scope/LineItemDetailsPage.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  containsAny27n115ngkvovr as containsAny,
  resize3py5p2yrjp6p7 as resize,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
} from '../../../../../../utils/utils.mjs';
import { withWritedlio9p0oewet as withWrite } from '../../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../../nav/AppDimensions.mjs';
import {
  divkhq3vjih9fcw as div,
  times2ukvaf6yk96p2 as times,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atBottomEnd1uhyy6gazj2pk as get_atBottomEnd,
  get_atEnd1cw5d2zgug26 as get_atEnd,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../../../../theming/colorManagement.mjs';
import { get_linked25zbblktmzgbh as get_linked } from '../../../../../../icons.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  title1ahgushtajx2d as title,
} from '../../../../../theming/Titles.mjs';
import { DisplayableStateSemantic2q119ycceacla as DisplayableStateSemantic } from '../../../../../theming/states.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../../theming/separators.mjs';
import {
  get_warningTextButton13ztryiioyzkv as get_warningTextButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_dangerButtonciwpmvl7jmt2 as get_dangerButton,
  specCenteredText33v0vmsdeuehr as specCenteredText_0,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
} from '../../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  voidItemAction20crlyymuzk79 as voidItemAction,
  denySelected4xcqjhjwclhe as denySelected,
  approveSelected1hdkbv3ottf9j as approveSelected,
} from '../approval.mjs';
import {
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
  assertViewerLens2aypbnpatof3k as assertViewerLens,
  ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance,
} from '../../../../../screens/common/ProjectView.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  renderPriceChangegxsbuhvani39 as renderPriceChange,
  priceWithChangedayxt0y21soj as priceWithChange,
} from '../../../../priceChanges.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../../sdk/UserSession.mjs';
import { MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance } from '../../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  labeledSection16775qn7m7foh as labeledSection,
  label287uhiq3m9m4z as label2,
} from '../../../../label2.mjs';
import { keyString2ezqnhf3jck9c as keyString } from '../../../../keyValue.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { forEachWithRenderer12ybmdeyp3omm as forEachWithRenderer } from '../../../../forEachWithRenderer.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { renderer1vumrhd66vl4m as renderer } from '../../../../../../extensions/RecyclerViewRendererSet.ext.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { RecyclerViewRendererSet341fhovxcnndi as RecyclerViewRendererSet } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/RecyclerViewRendererSet.mjs';
import { Data3qblafqxenieu as Data } from '../../../../../screens/common/AuthorizedProjectView.mjs';
import { compareBy2697bq0ffft96 as compareBy } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  plus310ted5e4i90h as plus,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ChangesRejectedDetails1h1y23it63u9u as ChangesRejectedDetails } from '../../../../../dialogs/BasicFlowForms.mjs';
import { ReactiveMutableSet2bktc9g3zyrtk as ReactiveMutableSet } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableSet.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_scrolling27q1yr4ng0cx8 as get_scrolling } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { InnerTabBar_getInstance20l55y0u7bopn as InnerTabBar_getInstance } from '../../../../../theming/tabs.mjs';
import { RadioToggleButton6jdt9lqh3p8p as RadioToggleButton } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioToggleButton.commonHtml.mjs';
import { equalTo2dio0vrcsd3je as equalTo } from '../../../../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var Section_Info_instance;
var Section_Items_instance;
function values() {
  return [Section_Info_getInstance(), Section_Items_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var Section_entriesInitialized;
function Section_initEntries() {
  if (Section_entriesInitialized)
    return Unit_instance;
  Section_entriesInitialized = true;
  Section_Info_instance = Section().ah9('Info', 0, 'Info');
  Section_Items_instance = Section().ah9('Items', 1, 'Items');
}
var $ENTRIES;
function *_generator_invoke__zhh2q8($this, $this$withWrite, sel, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.bh9_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var it = tmp;
  if (it.s94()) {
    if (sel) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = $this.ch9_1.sf5_1;
      var tmp_0 = await_0(this_1, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var tmp$ret$1 = tmp_0;
      $this.ch9_1.vf5_1.xam(tmp$ret$1);
    } else {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = $this.ch9_1.sf5_1;
      var tmp_1 = await_0(this_2, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var tmp$ret$2 = tmp_1;
      $this.ch9_1.vf5_1.zam(tmp$ret$2);
    }
  } else {
    if (sel)
      $this.ch9_1.vf5_1.lam(it.h40());
    else
      $this.ch9_1.vf5_1.kam(it.h40());
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.dh9_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  switch (tmp.b4_1) {
    case 3:
    case 2:
    case 0:
      break;
    case 1:
      var tmp_0 = JumpTo_getInstance().ng3_1;
      // Inline function 'com.lightningkite.reactive.context.invoke' call

      var this_1 = $this.eh9_1;
      var tmp_1 = await_0(this_1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var tmp$ret$1 = tmp_1;
      tmp_0.zg4(tmp$ret$1.h40());
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var tmp = JumpTo_getInstance().ng3_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.fh9_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.xg4(tmp$ret$0.h40(), $this.gh9_1);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.hh9_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp;
}
function itemCard($this, _this__u8e3s4, item, otherInfo) {
  var status = remember(VOID, VOID, VOID, ($this$remember) => get_status($this$remember.baj(item)));
  var line = remember(VOID, VOID, VOID, ($this$remember) => {
    var change = $this$remember.baj(item);
    var tmp;
    if (isInterface(change, LineItemInterface())) {
      tmp = change;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp0 = $this$remember.baj($this.mh9_1.tgm());
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (element.kf9_1.equals(change.r94())) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var tmp0_safe_receiver = tmp$ret$1;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp0_elvis_lhs = change.x94();
        var cutoff = tmp0_elvis_lhs == null ? change.y94() : tmp0_elvis_lhs;
        var tmp_1;
        if (cutoff == null) {
          tmp_1 = tmp0_safe_receiver;
        } else {
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance();
          var tmp$ret$3 = toDuration(1, DurationUnit_MINUTES_getInstance());
          var tmp1_elvis_lhs = tmp0_safe_receiver.sfy(cutoff.w26(tmp$ret$3), emptyList(), null);
          var tmp_2;
          if (tmp1_elvis_lhs == null) {
            tmp_2 = new (ChangeOrderDetails$ChangeItemCards$itemCard$line$2$1())(tmp0_safe_receiver);
          } else {
            tmp_2 = tmp1_elvis_lhs;
          }
          tmp_1 = tmp_2;
        }
        tmp_0 = tmp_1;
      }
      var tmp1_elvis_lhs_0 = tmp_0;
      var tmp_3;
      if (tmp1_elvis_lhs_0 == null) {
        throw NotFound().nfx(getKClass(LineItem()), null);
      } else {
        tmp_3 = tmp1_elvis_lhs_0;
      }
      tmp = tmp_3;
    }
    return tmp;
  });
  var tmp;
  if ($this.ih9_1) {
    var tmp_0 = remember(VOID, VOID, VOID, ($this$remember) => {
      var it = $this$remember.baj(item);
      return it.s94() ? containsAny($this$remember.baj($this.mh9_1.vf5_1), $this$remember.baj($this.mh9_1.sf5_1)) : $this$remember.baj($this.mh9_1.vf5_1).t1(it.h40());
    });
    var isSelected = withWrite(tmp_0, ChangeOrderDetails$ChangeItemCards$itemCard$slambda_0(item, $this.mh9_1));
    var tmp_1;
    if ($this.mh9_1.of5_1.xgj()) {
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())(_this__u8e3s4.pc());
      var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
      var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
      _this__u8e3s4.ebb(p, view);
      view.xbm(false);
      view.zb8(div(get_AppDimensions().ng2_1, 2));
      var tmp_2 = get_compact(view);
      // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (ToggleButton())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      dynamicTheme(view_0, ($this$dynamicTheme) => $this$dynamicTheme.baj(item).s94() ? ApprovedSemantic_getInstance().ybe(CardSemantic_getInstance()) : SectionSemantic_getInstance());
      var tmp_3 = get_centered(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (Checkbox())(view_0.pc());
      var tmp0_elvis_lhs_1 = view_0.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.ebb(p_1, view_1);
      view_1.xah(view_1.cbk_1, isSelected);
      view_0.fbb(p_1, view_1);
      view_0.jbb(tmp_3, view_1);
      view_0.xah(view_0.ncq_1, isSelected);
      view.fbb(p_0, view_0);
      view.jbb(tmp_2, view_0);
      var tmp_4 = view.ibb(get_expanding(view), get_lightSection(view));
      // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (ToggleButton())(view.pc());
      var tmp0_elvis_lhs_2 = view.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
      view.ebb(p_2, view_2);
      itemCard$content(view_2, $this, otherInfo, line, $this.mh9_1, item, status);
      view_2.xah(view_2.ncq_1, isSelected);
      view.fbb(p_2, view_2);
      view.jbb(tmp_4, view_2);
      _this__u8e3s4.fbb(p, view);
      tmp_1 = view;
    } else {
      tmp_1 = _this__u8e3s4.jbb(get_lightSection(_this__u8e3s4), itemCard$content(_this__u8e3s4, $this, otherInfo, line, $this.mh9_1, item, status));
    }
    tmp = tmp_1;
  } else {
    // Inline function 'com.lightningkite.kiteui.views.direct.link' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Link())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs_3 = _this__u8e3s4.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? _this__u8e3s4 : tmp0_elvis_lhs_3;
    _this__u8e3s4.ebb(p_3, view_3);
    dynamicTheme(view_3, ($this$dynamicTheme) => {
      var tmp;
      switch ($this$dynamicTheme.baj(status).b4_1) {
        case 0:
          tmp = ApprovedSemantic_getInstance().ybe(CardSemantic_getInstance());
          break;
        case 1:
          tmp = DeniedSemantic_getInstance().ybe(CardSemantic_getInstance());
          break;
        case 2:
          tmp = DarkSection_getInstance();
          break;
        case 3:
          tmp = LightSection_getInstance();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      return tmp;
    });
    itemCard$content(view_3, $this, otherInfo, line, $this.mh9_1, item, status);
    var tmp_5 = KMutableProperty0();
    var tmp_6 = Link$_get_to_$ref_jq7esp(view_3);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('to', 0, tmp_5, tmp_6, Link$_set_to_$ref_i9gu5x(view_3));
    reactiveScope(view_3, ($this$reactiveScope) => {
      var $this$invoke = $this$reactiveScope;
      var tmp;
      switch ($this$invoke.baj(status).b4_1) {
        case 3:
          tmp = null;
          break;
        case 2:
          tmp = null;
          break;
        case 1:
          tmp = $this$invoke.baj($this.mh9_1.uf5_1);
          break;
        case 0:
          tmp = () => new (LineItemDetailsPage())($this.mh9_1.mf5_1, $this$invoke.baj(item).r94(), $this.mh9_1.of5_1, $this.mh9_1);
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var tmp$ret$19 = tmp;
      this_0.set(tmp$ret$19);
      return Unit_instance;
    });
    view_3.tbw(ChangeOrderDetails$ChangeItemCards$itemCard$slambda_2(status, item));
    _this__u8e3s4.fbb(p_3, view_3);
    tmp = view_3;
  }
  return tmp;
}
function itemCard$content(_this__u8e3s4, this$0, $otherInfo, line, this$1, $item, status) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(times(get_AppDimensions().ng2_1, 2));
  launch(view, VOID, VOID, ChangeOrderDetails$ChangeItemCards$itemCard$content$slambda_0($item, view));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  var tmp = get_expanding(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(true);
  view_1.zb8(get_AppDimensions().ng2_1);
  var tmp_0 = get_italic(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.xbm(false);
  view_2.zb8(get_AppDimensions().ng2_1);
  if (this$0.ih9_1) {
    view_2.jbb(view_2.ibb(shownWhen(view_2, VOID, ($this$shownWhen) => $this$shownWhen.baj($item).s94()), colored(view_2, AppColors_getInstance().dfz_1.xg9_1)), icon(view_2, resize(get_linked(Companion_getInstance_0()), get_rem(1)), 'Linked'));
  }
  var tmp_1 = get_centered(view_2);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl_0(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb_0(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var tmp$ret$0 = $this$reactiveScope.baj($item).w94();
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view_2.fbb(p_3, view_3);
  view_2.jbb(tmp_1, view_3);
  view_2.jbb(get_centered(view_2), body(view_2, '\u2022'));
  var tmp_4 = get_centered(view_2);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.ebb(p_4, view_4);
  view_4.jba(view_4.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl_1(view_4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb_1(view_4));
  reactiveScope(view_4, ($this$reactiveScope) => {
    // Inline function 'kotlin.let' call
    var it = $this$reactiveScope.baj($item).z94();
    var tmp$ret$9 = $this$reactiveScope.baj(status).equals(ChangeStatus_Accepted_getInstance()) ? it.f95_1 : it.e95_1;
    this_1.set(tmp$ret$9);
    return Unit_instance;
  });
  view_2.fbb(p_4, view_4);
  view_2.jbb(tmp_4, view_4);
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_0, view_2);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_5 = view_1.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
  view_1.ebb(p_5, view_5);
  view_5.jba(view_5.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  var tmp_7 = KMutableProperty0();
  var tmp_8 = TextView$_get_content_$ref_4pzcwl_2(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_2(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var tmp$ret$20 = $this$reactiveScope.baj(line).k20();
    this_2.set(tmp$ret$20);
    return Unit_instance;
  });
  view_1.fbb(p_5, view_5);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp, view_1);
  var tmp_9 = get_atBottomEnd(view_0);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_6 = view_0.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_0 : tmp0_elvis_lhs_6;
  view_0.ebb(p_6, view_6);
  view_6.jba(view_6.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  dynamicTheme(view_6, ($this$dynamicTheme) => DisplayableStateSemantic().mgt($this$dynamicTheme.baj(status)));
  var tmp_10 = KMutableProperty0();
  var tmp_11 = TextView$_get_content_$ref_4pzcwl_3(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb_3(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    var tmp$ret$31 = $this$reactiveScope.baj(status).uh7_1;
    this_3.set(tmp$ret$31);
    return Unit_instance;
  });
  view_0.fbb(p_6, view_6);
  view_0.jbb(tmp_9, view_6);
  view.fbb(p_0, view_0);
  greySeparator(view);
  $otherInfo(view, line);
  if (this$0.ih9_1 && this$1.of5_1.equals(ProjectLens_Contractor_getInstance())) {
    var tmp_12 = view.ibb(view.ibb(shownWhen(view, VOID, ChangeOrderDetails$ChangeItemCards$itemCard$content$lambda), get_atEnd(view)), get_warningTextButton(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (Button())(view.pc());
    var tmp0_elvis_lhs_7 = view.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
    view.ebb(p_7, view_7);
    specCenteredText(view_7, 'Void');
    view_7.mbg(voidItemAction(view_7, ChangeOrderDetails$ChangeItemCards$itemCard$content$slambda_2($item)));
    view.fbb(p_7, view_7);
    view.jbb(tmp_12, view_7);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
var ChangeOrderDetails$ChangeItemCards$itemCard$line$2$1Class;
function ChangeOrderDetails$ChangeItemCards$itemCard$line$2$1() {
  if (ChangeOrderDetails$ChangeItemCards$itemCard$line$2$1Class === VOID) {
    class $ {
      constructor($item) {
        this.nh9_1 = $item;
        this.oh9_1 = Companion_instance.p91(0n);
      }
      v91() {
        return this.oh9_1;
      }
      k20() {
        return this.nh9_1.lf9_1;
      }
      q91() {
        return this.nh9_1.nf9_1;
      }
      r91() {
        return this.nh9_1.mf9_1;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [LineItemInterface()]);
    ChangeOrderDetails$ChangeItemCards$itemCard$line$2$1Class = $;
  }
  return ChangeOrderDetails$ChangeItemCards$itemCard$line$2$1Class;
}
var ChangeOrderDetails$ChangeItemCards$itemCard$slambdaClass;
function ChangeOrderDetails$ChangeItemCards$itemCard$slambda() {
  if (ChangeOrderDetails$ChangeItemCards$itemCard$slambdaClass === VOID) {
    class $ {
      constructor($item, this$0) {
        this.bh9_1 = $item;
        this.ch9_1 = this$0;
      }
      afz($this$withWrite, sel, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withWrite, sel), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ChangeOrderDetails$ChangeItemCards$itemCard$slambdaClass = $;
  }
  return ChangeOrderDetails$ChangeItemCards$itemCard$slambdaClass;
}
function ChangeOrderDetails$ChangeItemCards$itemCard$slambda_0($item, this$0) {
  var i = new (ChangeOrderDetails$ChangeItemCards$itemCard$slambda())($item, this$0);
  var l = ($this$withWrite, sel, $completion) => i.afz($this$withWrite, sel, $completion);
  l.$arity = 2;
  return l;
}
function Link$_get_to_$ref_jq7esp(p0) {
  return () => p0.xbv_1;
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return (_this__u8e3s4) => {
    p0.ibw(_this__u8e3s4);
    return Unit_instance;
  };
}
var ChangeOrderDetails$ChangeItemCards$itemCard$slambdaClass_0;
function ChangeOrderDetails$ChangeItemCards$itemCard$slambda_1() {
  if (ChangeOrderDetails$ChangeItemCards$itemCard$slambdaClass_0 === VOID) {
    class $ {
      constructor($status, $item) {
        this.dh9_1 = $status;
        this.eh9_1 = $item;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderDetails$ChangeItemCards$itemCard$slambdaClass_0 = $;
  }
  return ChangeOrderDetails$ChangeItemCards$itemCard$slambdaClass_0;
}
function ChangeOrderDetails$ChangeItemCards$itemCard$slambda_2($status, $item) {
  var i = new (ChangeOrderDetails$ChangeItemCards$itemCard$slambda_1())($status, $item);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function ChangeOrderDetails$ChangeItemCards$cancelledItem$lambda$lambda($this$itemCard, line) {
  // Inline function 'com.crowpay.views.components.keyView' call
  var key = 'Price Change';
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$itemCard.pc());
  var tmp0_elvis_lhs = $this$itemCard.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$itemCard : tmp0_elvis_lhs;
  $this$itemCard.ebb(p, view);
  view.xbm(false);
  view.zb8(get_rem_0(0.5));
  bodyBold(view, key + ':');
  var tmp = get_expanding(view);
  var tmp$ret$0 = renderPriceChange(view, false, ($this$renderPriceChange) => new (MonetaryValue())(MonetaryValue__unaryMinus_impl_x5smq0($this$renderPriceChange.baj(line).v91())));
  view.jbb(tmp, tmp$ret$0);
  $this$itemCard.fbb(p, view);
  return Unit_instance;
}
var ChangeOrderDetails$ChangeItemCards$itemCard$content$slambdaClass;
function ChangeOrderDetails$ChangeItemCards$itemCard$content$slambda() {
  if (ChangeOrderDetails$ChangeItemCards$itemCard$content$slambdaClass === VOID) {
    class $ {
      constructor($item, $$this$col) {
        this.fh9_1 = $item;
        this.gh9_1 = $$this$col;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderDetails$ChangeItemCards$itemCard$content$slambdaClass = $;
  }
  return ChangeOrderDetails$ChangeItemCards$itemCard$content$slambdaClass;
}
function ChangeOrderDetails$ChangeItemCards$itemCard$content$slambda_0($item, $$this$col) {
  var i = new (ChangeOrderDetails$ChangeItemCards$itemCard$content$slambda())($item, $$this$col);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function ChangeOrderDetails$ChangeItemCards$itemCard$content$lambda($this$shownWhen) {
  var tmp0_safe_receiver = $this$shownWhen.baj($this$shownWhen.baj(get_session()).pfw_1).m88_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j8c_1;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var role = tmp;
  return role.d4(MemberRole_Manager_getInstance()) >= 0;
}
var ChangeOrderDetails$ChangeItemCards$itemCard$content$slambdaClass_0;
function ChangeOrderDetails$ChangeItemCards$itemCard$content$slambda_1() {
  if (ChangeOrderDetails$ChangeItemCards$itemCard$content$slambdaClass_0 === VOID) {
    class $ {
      constructor($item) {
        this.hh9_1 = $item;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderDetails$ChangeItemCards$itemCard$content$slambdaClass_0 = $;
  }
  return ChangeOrderDetails$ChangeItemCards$itemCard$content$slambdaClass_0;
}
function ChangeOrderDetails$ChangeItemCards$itemCard$content$slambda_2($item) {
  var i = new (ChangeOrderDetails$ChangeItemCards$itemCard$content$slambda_1())($item);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $this$launch, $completion) {
  var tmp = assertViewerLens($this.ph9_1, $this.ph9_1.of5_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $this$withWrite, sel, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.qh9_1.rf5_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (get_pending(element)) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item = _iterator__ex2g4s_0.o1();
    var tmp$ret$4 = item.h40();
    destination_0.v(tmp$ret$4);
  }
  var ids = destination_0;
  if (sel)
    $this.qh9_1.vf5_1.xam(ids);
  else
    $this.qh9_1.vf5_1.zam(ids);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.rh9_1.rf5_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if ($this.rh9_1.vf5_1.kl(element.h40())) {
      destination.v(element);
    }
  }
  return destination;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.sh9_1.rf5_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if ($this.sh9_1.vf5_1.kl(element.h40())) {
      destination.v(element);
    }
  }
  return destination;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var tmp = get_mainPageNavigator($this.th9_1);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.uh9_1.uf5_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.dbw(tmp$ret$0());
  return Unit_instance;
}
var SectionClass;
function Section() {
  if (SectionClass === VOID) {
    class $ extends Enum() {
      static ah9(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.zh8_1 = displayName;
        return $this;
      }
      g90() {
        return this.zh8_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'Section', VOID, VOID, [HasDisplayName(), Enum()]);
    SectionClass = $;
  }
  return SectionClass;
}
function infoSection($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  labeledSection(view, 'Description', ($this$labeledSection) => {
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$labeledSection.pc());
    var tmp0_elvis_lhs = $this$labeledSection.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$labeledSection : tmp0_elvis_lhs;
    $this$labeledSection.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_6(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_6(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.baj($this.pf5_1).t57_1;
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    $this$labeledSection.fbb(p, view);
    return Unit_instance;
  });
  labeledSection(view, 'Summary', ($this$labeledSection) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$labeledSection.pc());
    var tmp0_elvis_lhs = $this$labeledSection.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$labeledSection : tmp0_elvis_lhs;
    $this$labeledSection.ebb(p, view);
    view.xbm(true);
    keyString(view, 'Group Change', ($this$keyString) => $this$keyString.baj($this.pf5_1).w57_1 ? 'Yes' : 'No');
    keyString(view, 'Submitted', ($this$keyString) => {
      var tmp0_safe_receiver = $this$keyString.baj($this.pf5_1).v57_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : format(tmp0_safe_receiver, Formats_getInstance().k8z_1);
      return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    });
    // Inline function 'com.crowpay.views.components.keyView' call
    var key = 'Change Amount';
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    view_0.zb8(get_rem_0(0.5));
    bodyBold(view_0, key + ':');
    var tmp = get_expanding(view_0);
    var tmp$ret$9 = renderPriceChange(view_0, false, ($this$renderPriceChange) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$renderPriceChange.baj($this.rf5_1);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp0_elvis_lhs = element.u94();
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
          tmp_0 = Companion_instance.p91(0n);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$7 = tmp_0;
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$7);
      }
      var tmp$ret$8 = sum;
      return new (MonetaryValue())(tmp$ret$8);
    });
    view_0.jbb(tmp, tmp$ret$9);
    view.fbb(p_0, view_0);
    $this$labeledSection.fbb(p, view);
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return view;
}
function itemsSection($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var pending = lens($this.rf5_1, ChangeOrderDetails$itemsSection$lambda);
  var reviewed = lens($this.rf5_1, ChangeOrderDetails$itemsSection$lambda_0);
  var tmp = view.ibb(shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.baj(pending).i1();
  }), view.hbb(ReviewSelectionSemantic_getInstance()));
  view.jbb(tmp, label2(view, 'Pending Items', VOID, ($this$label2) => {
    var tmp;
    if ($this.of5_1.xgj()) {
      $this$label2.dba(times(get_AppDimensions().ng2_1, 2));
      tmp = Unit_instance;
    }
    var renderers = new (ChangeItemCards())($this, true);
    var tmp_0;
    if ($this.of5_1.xgj()) {
      var tmp_1 = $this$label2.ibb(get_lightSection($this$label2), get_compact($this$label2));
      // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (ToggleButton())($this$label2.pc());
      var tmp0_elvis_lhs = $this$label2.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
      $this$label2.ebb(p, view);
      var tmp_2 = remember(VOID, VOID, VOID, ($this$remember) => {
        var tmp = $this$remember.baj($this.vf5_1);
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = $this$remember.baj($this.rf5_1);
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (get_pending(element)) {
            destination.v(element);
          }
        }
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
        var _iterator__ex2g4s_0 = destination.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var item = _iterator__ex2g4s_0.o1();
          var tmp$ret$4 = item.h40();
          destination_0.v(tmp$ret$4);
        }
        return tmp.l3(destination_0);
      });
      var allSelected = withWrite(tmp_2, ChangeOrderDetails$itemsSection$lambda$slambda_0($this));
      view.xah(view.ncq_1, allSelected);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view_0.xbm(false);
      var tmp_3 = get_centered(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (Checkbox())(view_0.pc());
      var tmp0_elvis_lhs_1 = view_0.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.ebb(p_1, view_1);
      view_1.xah(view_1.cbk_1, allSelected);
      view_0.fbb(p_1, view_1);
      view_0.jbb(tmp_3, view_1);
      view_0.jbb(get_centered(view_0), body(view_0, 'Select All'));
      view.fbb(p_0, view_0);
      $this$label2.fbb(p, view);
      $this$label2.jbb(tmp_1, view);
      tmp_0 = Unit_instance;
    }
    var tmp_4 = $this$label2.hbb(ListSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())($this$label2.pc());
    var tmp0_elvis_lhs_2 = $this$label2.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? $this$label2 : tmp0_elvis_lhs_2;
    $this$label2.ebb(p_2, view_2);
    view_2.xbm(true);
    forEachWithRenderer(view_2, pending, renderers);
    $this$label2.fbb(p_2, view_2);
    return $this$label2.jbb(tmp_4, view_2);
  }));
  var tmp_0 = shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.baj(reviewed).i1();
  });
  view.jbb(tmp_0, label2(view, 'Reviewed Items', VOID, ($this$label2) => {
    var renderers = new (ChangeItemCards())($this, false);
    var tmp = $this$label2.hbb(ListSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$label2.pc());
    var tmp0_elvis_lhs = $this$label2.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
    $this$label2.ebb(p, view);
    view.xbm(true);
    forEachWithRenderer(view, reviewed, renderers);
    $this$label2.fbb(p, view);
    return $this$label2.jbb(tmp, view);
  }));
  _this__u8e3s4.fbb(p, view);
  return view;
}
function actionBar($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_AppDimensions().ig2_1);
  var pending = lens($this.rf5_1, ChangeOrderDetails$actionBar$lambda);
  var allSelected = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    var tmp0 = $this$remember.baj(pending);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_0;
      if (isInterface(tmp0, Collection())) {
        tmp_0 = tmp0.i1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (!$this$remember.baj($this.vf5_1).t1(element.h40())) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    if (tmp$ret$0) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$remember.baj(pending).i1();
    } else {
      tmp = false;
    }
    return tmp;
  });
  var labelValue = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(allSelected) ? ' All' : $this$remember.baj($this.vf5_1).p1() > 1 ? ' (' + $this.vf5_1.p1() + ')' : '');
  var canApprove = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    var tmp_0;
    if ($this.of5_1.equals(ProjectLens_Customer_getInstance())) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !$this$remember.baj(pending).i1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$remember.baj($this.vf5_1).i1();
    } else {
      tmp = false;
    }
    return tmp;
  });
  var canReject = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    var tmp_0;
    if ($this.of5_1.equals(ProjectLens_Customer_getInstance())) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !$this$remember.baj(pending).i1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$remember.baj($this.vf5_1).i1();
    } else {
      tmp = false;
    }
    return tmp;
  });
  if ($this.of5_1.equals(ProjectLens_Customer_getInstance())) {
    var tmp = get_dangerButton(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Button())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    shownDefaultFalse(view_0, ($this$shownDefaultFalse) => $this$shownDefaultFalse.baj(canReject));
    specCenteredText_0(view_0, ($this$specCenteredText) => 'Reject' + $this$specCenteredText.baj(labelValue));
    view_0.mbg(denySelected(view_0, ChangeOrderDetails$actionBar$slambda_0($this)));
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
    var tmp_0 = get_primaryButton(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Button())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    shownDefaultFalse(view_1, ($this$shownDefaultFalse) => $this$shownDefaultFalse.baj(canApprove));
    specCenteredText_0(view_1, ($this$specCenteredText) => 'Approve' + $this$specCenteredText.baj(labelValue));
    view_1.mbg(approveSelected(view_1, ChangeOrderDetails$actionBar$slambda_2($this)));
    view.fbb(p_1, view_1);
    view.jbb(tmp_0, view_1);
  }
  if ($this.of5_1.equals(ProjectLens_Contractor_getInstance())) {
    var tmp_1 = get_secondaryButton(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Button())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    var tmp_2 = KMutableProperty0();
    var tmp_3 = Button$_get_shown_$ref_hkylj1(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp_2, tmp_3, Button$_set_shown_$ref_bpvuvj(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp0 = $this$reactiveScope.baj($this.rf5_1);
      var tmp$ret$13;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp;
        if (isInterface(tmp0, Collection())) {
          tmp = tmp0.i1();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$13 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (get_status(element).equals(ChangeStatus_Rejected_getInstance())) {
            tmp$ret$13 = true;
            break $l$block_2;
          }
        }
        tmp$ret$13 = false;
      }
      var tmp$ret$15 = tmp$ret$13;
      this_0.set(tmp$ret$15);
      return Unit_instance;
    });
    specCenteredText(view_2, 'View Concerns');
    onClick(view_2, VOID, VOID, ChangeOrderDetails$actionBar$slambda_4(view_2, $this));
    view.fbb(p_2, view_2);
    view.jbb(tmp_1, view_2);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
var ChangeItemCardsClass;
function ChangeItemCards() {
  if (ChangeItemCardsClass === VOID) {
    class $ {
      constructor($outer, approving) {
        this.mh9_1 = $outer;
        this.ih9_1 = approving;
        var tmp = this;
        tmp.jh9_1 = renderer(this, ($this$renderer, item, _unused_var__etf5q3) => itemCard(this, $this$renderer, item, ($this$itemCard, it) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$itemCard.pc());
          var tmp0_elvis_lhs = $this$itemCard.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$itemCard : tmp0_elvis_lhs;
          $this$itemCard.ebb(p, view);
          view.xbm(true);
          // Inline function 'com.crowpay.views.components.keyView' call
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view_0.xbm(false);
          view_0.zb8(get_rem_0(0.5));
          bodyBold(view_0, 'Price' + ':');
          var tmp = get_expanding(view_0);
          var tmp$ret$0 = renderPriceChange(view_0, false, ($this$renderPriceChange) => new (MonetaryValue())($this$renderPriceChange.baj(item).a76_1));
          view_0.jbb(tmp, tmp$ret$0);
          view.fbb(p_0, view_0);
          var tmp_0 = shownWhen(view, VOID, ($this$shownWhen) => {
            // Inline function 'kotlin.text.isNotBlank' call
            var this_0 = $this$shownWhen.baj(item).z75_1;
            return !isBlank(this_0);
          });
          view.jbb(tmp_0, label2(view, 'Description', VOID, ($this$label2) => {
            // Inline function 'com.crowpay.views.theming.body' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (TextView())($this$label2.pc());
            var tmp0_elvis_lhs = $this$label2.cbb_1;
            var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
            $this$label2.ebb(p, view);
            view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
            var tmp = KMutableProperty0();
            var tmp_0 = TextView$_get_content_$ref_4pzcwl(view);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(view));
            reactiveScope(view, ($this$reactiveScope) => {
              var tmp$ret$7 = $this$reactiveScope.baj(item).z75_1;
              this_0.set(tmp$ret$7);
              return Unit_instance;
            });
            $this$label2.fbb(p, view);
            return view;
          }));
          $this$itemCard.fbb(p, view);
          return Unit_instance;
        }));
        var tmp_0 = this;
        tmp_0.kh9_1 = renderer(this, ($this$renderer, item, _unused_var__etf5q3) => itemCard(this, $this$renderer, item, ($this$itemCard, line) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$itemCard.pc());
          var tmp0_elvis_lhs = $this$itemCard.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$itemCard : tmp0_elvis_lhs;
          $this$itemCard.ebb(p, view);
          view.xbm(true);
          var tmp = shownWhen(view, VOID, ($this$shownWhen) => {
            var tmp = $this$shownWhen.baj(item).h72_1;
            return !((tmp == null ? null : new (MonetaryValue())(tmp)) == null);
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view_0.xbm(true);
          // Inline function 'com.crowpay.views.components.keyView' call
          var key = 'Price Change';
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.ebb(p_1, view_1);
          view_1.xbm(false);
          view_1.zb8(get_rem_0(0.5));
          bodyBold(view_1, key + ':');
          var tmp_0 = get_expanding(view_1);
          var tmp$ret$18 = renderPriceChange(view_1, false, ($this$renderPriceChange) => {
            var tmp = $this$renderPriceChange.baj(item).h72_1;
            return tmp == null ? null : new (MonetaryValue())(tmp);
          });
          view_1.jbb(tmp_0, tmp$ret$18);
          view_0.fbb(p_1, view_1);
          // Inline function 'com.crowpay.views.components.keyView' call
          var key_0 = 'New Price';
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_2 = view_0.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
          view_0.ebb(p_2, view_2);
          view_2.xbm(false);
          view_2.zb8(get_rem_0(0.5));
          bodyBold(view_2, key_0 + ':');
          var tmp_1 = get_expanding(view_2);
          var tmp_2 = ($this$priceWithChange) => {
            var tmp = $this$priceWithChange.baj(line).v91();
            var tmp0_elvis_lhs = $this$priceWithChange.baj(item).h72_1;
            var tmp_0;
            var tmp_1 = tmp0_elvis_lhs;
            if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
              tmp_0 = Companion_instance.p91(0n);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            return new (MonetaryValue())(MonetaryValue__plus_impl_c1ylt(tmp, tmp_0));
          };
          var tmp$ret$24 = priceWithChange(view_2, false, tmp_2, ($this$priceWithChange) => {
            var tmp = $this$priceWithChange.baj(item).h72_1;
            return tmp == null ? null : new (MonetaryValue())(tmp);
          });
          view_2.jbb(tmp_1, tmp$ret$24);
          view_0.fbb(p_2, view_2);
          view.fbb(p_0, view_0);
          view.jbb(tmp, view_0);
          keyString(view, 'Updated Description', ($this$keyString) => $this$keyString.baj(item).g72_1);
          $this$itemCard.fbb(p, view);
          return Unit_instance;
        }));
        var tmp_1 = this;
        tmp_1.lh9_1 = renderer(this, ($this$renderer, item, _unused_var__etf5q3) => itemCard(this, $this$renderer, item, ChangeOrderDetails$ChangeItemCards$cancelledItem$lambda$lambda));
      }
      vh9(item) {
        return item.h40();
      }
      idg(item) {
        return this.vh9((!(item == null) ? isInterface(item, ChangeRequestItem()) : false) ? item : THROW_CCE());
      }
      wh9(item) {
        var tmp;
        if (item instanceof PendingLineItem()) {
          tmp = this.jh9_1;
        } else {
          if (item instanceof PendingItemChange()) {
            tmp = item.i72_1 ? this.lh9_1 : this.kh9_1;
          } else {
            throw IllegalStateException().o4('Unsupported ChangeRequestItem: ' + toString(item));
          }
        }
        return tmp;
      }
      hdg(item) {
        return this.wh9((!(item == null) ? isInterface(item, ChangeRequestItem()) : false) ? item : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ChangeItemCards', VOID, VOID, [RecyclerViewRendererSet()]);
    ChangeItemCardsClass = $;
  }
  return ChangeItemCardsClass;
}
function ChangeOrderDetails$comparator$lambda(it) {
  return !it.s94();
}
function ChangeOrderDetails$comparator$lambda_0(it) {
  return it.w94();
}
var ChangeOrderDetails$render$slambdaClass;
function ChangeOrderDetails$render$slambda() {
  if (ChangeOrderDetails$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ph9_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderDetails$render$slambdaClass = $;
  }
  return ChangeOrderDetails$render$slambdaClass;
}
function ChangeOrderDetails$render$slambda_0(this$0) {
  var i = new (ChangeOrderDetails$render$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function ChangeOrderDetails$itemsSection$lambda(it) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = it.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (get_pending(element)) {
      destination.v(element);
    }
  }
  return destination;
}
function ChangeOrderDetails$itemsSection$lambda_0(it) {
  // Inline function 'kotlin.collections.filterNot' call
  // Inline function 'kotlin.collections.filterNotTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = it.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (!get_pending(element)) {
      destination.v(element);
    }
  }
  return destination;
}
var ChangeOrderDetails$itemsSection$lambda$slambdaClass;
function ChangeOrderDetails$itemsSection$lambda$slambda() {
  if (ChangeOrderDetails$itemsSection$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.qh9_1 = this$0;
      }
      afz($this$withWrite, sel, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$withWrite, sel), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ChangeOrderDetails$itemsSection$lambda$slambdaClass = $;
  }
  return ChangeOrderDetails$itemsSection$lambda$slambdaClass;
}
function ChangeOrderDetails$itemsSection$lambda$slambda_0(this$0) {
  var i = new (ChangeOrderDetails$itemsSection$lambda$slambda())(this$0);
  var l = ($this$withWrite, sel, $completion) => i.afz($this$withWrite, sel, $completion);
  l.$arity = 2;
  return l;
}
function ChangeOrderDetails$actionBar$lambda(it) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = it.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (get_pending(element)) {
      destination.v(element);
    }
  }
  return destination;
}
var ChangeOrderDetails$actionBar$slambdaClass;
function ChangeOrderDetails$actionBar$slambda() {
  if (ChangeOrderDetails$actionBar$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.rh9_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderDetails$actionBar$slambdaClass = $;
  }
  return ChangeOrderDetails$actionBar$slambdaClass;
}
function ChangeOrderDetails$actionBar$slambda_0(this$0) {
  var i = new (ChangeOrderDetails$actionBar$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ChangeOrderDetails$actionBar$slambdaClass_0;
function ChangeOrderDetails$actionBar$slambda_1() {
  if (ChangeOrderDetails$actionBar$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.sh9_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderDetails$actionBar$slambdaClass_0 = $;
  }
  return ChangeOrderDetails$actionBar$slambdaClass_0;
}
function ChangeOrderDetails$actionBar$slambda_2(this$0) {
  var i = new (ChangeOrderDetails$actionBar$slambda_1())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_shown_$ref_hkylj1(p0) {
  return () => p0.wb8();
}
function Button$_set_shown_$ref_bpvuvj(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var ChangeOrderDetails$actionBar$slambdaClass_1;
function ChangeOrderDetails$actionBar$slambda_3() {
  if (ChangeOrderDetails$actionBar$slambdaClass_1 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.th9_1 = $$this$button;
        this.uh9_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderDetails$actionBar$slambdaClass_1 = $;
  }
  return ChangeOrderDetails$actionBar$slambdaClass_1;
}
function ChangeOrderDetails$actionBar$slambda_4($$this$button, this$0) {
  var i = new (ChangeOrderDetails$actionBar$slambda_3())($$this$button, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Section_Info_getInstance() {
  Section_initEntries();
  return Section_Info_instance;
}
function Section_Items_getInstance() {
  Section_initEntries();
  return Section_Items_instance;
}
var ChangeOrderDetailsClass;
function ChangeOrderDetails() {
  if (ChangeOrderDetailsClass === VOID) {
    class $ {
      constructor(projectId, changeId, lens, parent) {
        parent = parent === VOID ? null : parent;
        var tmp = this;
        tmp.lf5_1 = parent == null ? new (Data())(lens, projectId) : parent;
        this.mf5_1 = projectId;
        this.nf5_1 = changeId;
        this.of5_1 = lens;
        var tmp_0 = this;
        tmp_0.pf5_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.find' call
          var tmp0 = $this$remember.baj(this.vgv());
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.q57_1.equals(this.nf5_1)) {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw NotFound().nfx(getKClass(ChangeRequest()), null);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        });
        var tmp_1 = this;
        var tmp_2 = ChangeOrderDetails$comparator$lambda;
        tmp_1.qf5_1 = compareBy([tmp_2, ChangeOrderDetails$comparator$lambda_0]);
        var tmp_3 = this;
        tmp_3.rf5_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.baj(this.igt());
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.e72_1.equals(this.nf5_1)) {
              destination.v(element);
            }
          }
          var tmp = destination;
          // Inline function 'kotlin.collections.filter' call
          var tmp0_0 = $this$remember.baj(this.jgt());
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_0 = tmp0_0.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            if (element_0.x75_1.equals(this.nf5_1)) {
              destination_0.v(element_0);
            }
          }
          return sortedWith(plus(tmp, destination_0), this.qf5_1);
        });
        var tmp_4 = this;
        tmp_4.sf5_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.baj(this.rf5_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.s94()) {
              destination.v(element);
            }
          }
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
          var _iterator__ex2g4s_0 = destination.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var item = _iterator__ex2g4s_0.o1();
            var tmp$ret$12 = item.h40();
            destination_0.v(tmp$ret$12);
          }
          return destination_0;
        });
        var tmp_5 = this;
        tmp_5.tf5_1 = remember(VOID, VOID, VOID, ($this$remember) => status($this$remember.baj(this.pf5_1), $this$remember.baj(this.rf5_1)));
        var tmp_6 = this;
        tmp_6.uf5_1 = remember(VOID, VOID, VOID, ($this$remember) => () => new (ChangesRejectedDetails())($this$remember.baj(this.pf5_1), $this$remember.baj(this.rf5_1), $this$remember.baj(this.wgk()).f5c_1, $this$remember.baj(this.fgl()).x5i_1));
        this.vf5_1 = ReactiveMutableSet().zan();
        var tmp_7 = this;
        tmp_7.wf5_1 = remember(VOID, VOID, VOID, ($this$remember) => 'Change #' + $this$remember.baj(this.pf5_1).b58_1);
        this.xf5_1 = Signal().fak(Section_Items_getInstance());
      }
      jf8() {
        return this.mf5_1;
      }
      ucv() {
        return this.wf5_1;
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        launch(view, VOID, VOID, ChangeOrderDetails$render$slambda_0(this));
        var tmp = view.ibb(get_expanding(view), get_scrolling(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        view_0.zb8(get_AppDimensions().zg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        var tmp_0 = get_lightSection(view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        title(view_2, ($this$title) => {
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_4($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_4($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            // Inline function 'kotlin.let' call
            var it = $this$reactiveScope.baj(this.pf5_1);
            var tmp$ret$2 = 'Change #' + it.b58_1 + ': ' + it.s57_1;
            this_0.set(tmp$ret$2);
            return Unit_instance;
          });
          return Unit_instance;
        });
        label2(view_2, 'Status', VOID, ($this$label2) => title($this$label2, ($this$title) => {
          dynamicTheme($this$title, ($this$dynamicTheme) => DisplayableStateSemantic().mgt($this$dynamicTheme.baj(this.tf5_1)));
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl_5($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_5($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            var tmp$ret$4 = $this$reactiveScope.baj(this.tf5_1).zh7_1;
            this_0.set(tmp$ret$4);
            return Unit_instance;
          });
          return Unit_instance;
        }));
        view_1.fbb(p_2, view_2);
        view_1.jbb(tmp_0, view_2);
        view_0.fbb(p_1, view_1);
        var tmp_1 = view_0.hbb(InnerTabBar_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_3 = view_0.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
        view_0.ebb(p_3, view_3);
        view_3.xbm(false);
        var _iterator__ex2g4s = get_entries().m1();
        while (_iterator__ex2g4s.n1()) {
          var section = _iterator__ex2g4s.o1();
          var tmp_2 = get_expanding(view_3);
          // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
          var tmp$ret$14 = view_3.hbb(ButtonSemantic_getInstance());
          var tmp_3 = view_3.ibb(tmp_2, tmp$ret$14);
          // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (RadioToggleButton())(view_3.pc());
          var tmp0_elvis_lhs_4 = view_3.cbb_1;
          var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
          view_3.ebb(p_4, view_4);
          view_4.jbb(get_centered(view_4), body(view_4, section.zh8_1));
          view_4.xah(view_4.zc8_1, equalTo(this.xf5_1, section));
          view_3.fbb(p_4, view_4);
          view_3.jbb(tmp_3, view_4);
        }
        view_0.fbb(p_3, view_3);
        view_0.jbb(tmp_1, view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Frame())(view_0.pc());
        var tmp0_elvis_lhs_5 = view_0.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_0 : tmp0_elvis_lhs_5;
        view_0.ebb(p_5, view_5);
        var $this$frame = view_5;
        reactive($this$frame, ($this$reactive) => {
          $this$frame.zb9();
          var tmp;
          switch ($this$reactive.baj(this.xf5_1).b4_1) {
            case 0:
              tmp = infoSection(this, $this$frame);
              break;
            case 1:
              tmp = itemsSection(this, $this$frame);
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          return tmp;
        });
        view_0.fbb(p_5, view_5);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        var tmp_4 = get_darkSection(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_6 = view.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
        view.ebb(p_6, view_6);
        view_6.xbm(false);
        view_6.zb8(get_AppDimensions().ig2_1);
        var tmp_5 = get_expanding(view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Space())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.ebb(p_7, view_7);
        view_6.fbb(p_7, view_7);
        view_6.jbb(tmp_5, view_7);
        actionBar(this, view_6);
        view.fbb(p_6, view_6);
        view.jbb(tmp_4, view_6);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
      jfy() {
        return this.lf5_1.jfy();
      }
      tgm() {
        return this.lf5_1.tgm();
      }
      xgz() {
        return this.lf5_1.xgz();
      }
      wgk() {
        return this.lf5_1.wgk();
      }
      fgl() {
        return this.lf5_1.fgl();
      }
      ugm() {
        return this.lf5_1.ugm();
      }
      vgv() {
        return this.lf5_1.vgv();
      }
      lgy() {
        return this.lf5_1.lgy();
      }
      igt() {
        return this.lf5_1.igt();
      }
      jgt() {
        return this.lf5_1.jgt();
      }
      hgt() {
        return this.lf5_1.hgt();
      }
      bgt() {
        return this.lf5_1.bgt();
      }
      egt() {
        return this.lf5_1.egt();
      }
      ngf() {
        return this.lf5_1.ngf();
      }
      oh2() {
        return this.lf5_1.oh2();
      }
      mgf() {
        return this.lf5_1.mgf();
      }
      sh2() {
        return this.lf5_1.sh2();
      }
    }
    initMetadataForClass($, 'ChangeOrderDetails', VOID, VOID, [Page()]);
    ChangeOrderDetailsClass = $;
  }
  return ChangeOrderDetailsClass;
}
//region block: exports
export {
  ChangeOrderDetails as ChangeOrderDetails3bhfjfcpbf0qv,
};
//endregion

//# sourceMappingURL=ChangeOrderDetails.mjs.map
